import React, { Component } from 'react';
import { Form, Row, Col, Button, Table, DatePicker, Spin } from 'antd';
import { Select, ConfigProvider, Icon, Breadcrumb, message } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import moment from 'moment';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import { Translation, withTranslation } from 'react-i18next';
import i18n from 'i18next';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import throttle from 'lodash.throttle';
import './Charts.css';
import TableEmpty from '../components/TableEmpty.js';
import { formatDate, getParams, changeListWidth } from '../utils';
import { getInstitutionOptions, formatFromTime, formatToTime } from '../utils';
import { institutionRecord, calcTableHeight, showMoreSearch } from '../utils';
import { breadItem, breadBack } from '../utils';

import echarts from 'echarts/lib/echarts';
// 引入柱状图
import 'echarts/lib/chart/bar';
// 引入饼图
import 'echarts/lib/chart/pie';
//引入图例组件
import 'echarts/lib/component/legend';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
//导出excel插件
import ExportJsonExcel from 'js-export-excel';
class ChartsWithData extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
    match: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      title: '',
      uploadType: props.match.params.id,
      page: 1,
      fromTime: formatDate(new Date(), 'YYYY-MM-DD') + ' 0:0:0',
      toTime: formatDate(new Date(), 'YYYY-MM-DD') + ' 23:59:59',
      institutionName: '',
      loadingIconShow: false,
      institutionData: [],
      i18nextLng: 'zh-CN',
      listWidth: 'calc(87% - 8px)',
      sexStat: [], //性别柱状图数据
      recordList: [], //表格数据
      piechart: {}, //分类饼图数据
      tableHeight: 0,
      moreFilter: true,
      showMoreFilter: false,
      isLoading: false,
    };

    this.throttledDicomstat = throttle(newState => {
      this.dicomstat(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      const newHeight = calcTableHeight(189) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  componentWillReceiveProps(newProps) {
    const _this = this;
    if (newProps.match.url !== this.props.match.url) {
      setTimeout(function() {
        _this.props.form.resetFields();
        _this.setState({
          uploadType: newProps.match.params.id,
          total: 0,
          title: '',
          page: 1,
          fromTime: formatDate(new Date(), 'YYYY-MM-DD') + ' 0:0:0',
          toTime: formatDate(new Date(), 'YYYY-MM-DD') + ' 24:59:59',
          institutionName: '',
          loadingIconShow: false,
          institutionData: [],
          sexStat: [], //性别柱状图数据
          recordList: [], //表格数据
          piechart: {}, //分类饼图数据
        });
        _this.pageInit();
      }, 5);
    }
  }

  componentDidMount() {
    this.pageInit();
    let _this = this;
    window.addEventListener('resize', function() {
      _this.formResize();
    });
    this.formResize();
  }

  componentDidUpdate() {
    // const currentLang = window.localStorage.getItem('i18nextLng');
    // if (currentLang !== this.state.i18nextLng) {
    //   this.setState({
    //     i18nextLng: currentLang,
    //   });
    // }
  }

  pageInit() {
    this.throttledDicomstat();
    this.setTitle();
    this.getInstitutionData('');
  }

  setTitle = () => {
    //设置页面小标题
    let titleArray = ['疾病', '关键点', '异物', '正侧位'];
    titleArray = titleArray.concat(['', 'viralPneumonia', '', 'QC']);
    titleArray = titleArray.concat(['lung_disease', '', '肺结核']);
    const title = titleArray[parseInt(this.state.uploadType) - 1];
    this.setState({ title });
  };

  //获取列表
  dicomstat = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      aiProductType: updatedState.uploadType,
      fromTime: updatedState.fromTime,
      toTime: updatedState.toTime,
      institutionId: updatedState.institutionId,
    };
    apis.getDicomstat(post).then(result => {
      this.setState({ loadingIconShow: false });
      if (result.code === '0') {
        this.setState({
          sexStat: result.data.sexStat,
          recordList: result.data.recordList,
          piechart: result.data.piechart,
        });
        this.setSexChart();
        // this.setPieChart();
      } else {
        message.error(result.message);
        if (result.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //点击搜索按钮
  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        let fromTime = formatFromTime(values.time);
        let toTime = formatToTime(values.time);

        if (!fromTime || !toTime) {
          message.warning('请选择起止时间');
          return;
        }
        const newState = {
          fromTime,
          toTime,
          institutionId: values.institution,
          loadingIconShow: true,
        };

        this.throttledDicomstat(newState);
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    this.props.form.resetFields();
    this.getInstitutionData();
  };

  //获取机构列表
  getInstitutionData = async name => {
    const data = await institutionRecord(name);
    this.setState({ institutionData: data });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    this.getInstitutionData(value);
  };

  getColumns = () => {
    const { uploadType } = this.state;
    const columns = [];
    columns.push(
      {
        title: i18n.t('institution'), //机构
        dataIndex: 'institutionName',
        key: 'institutionName',
        width: '15%',
      },
      {
        title: i18n.t('uploads'), //传片量
        dataIndex: 'total',
        key: 'total',
        width: '10%',
      },
      {
        title: i18n.t('chestPA'), //胸部正位片
        dataIndex: 'chest_pa',
        key: 'chest_pa',
        width: '10%',
      }
    );
    if (uploadType === '6') {
      columns.push(
        {
          title: '患者数',
          dataIndex: 'patCnt',
          key: 'patCnt',
          width: '10%',
        },
        {
          title: 'AI',
          children: [
            {
              title: i18n.t('abnormal1'), //异常
              dataIndex: 'abnormal',
              key: 'abnormal',
              width: '10%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
            {
              title: i18n.t('uncertain'), //疑似
              dataIndex: 'viral_pneumonia',
              key: 'viral_pneumonia',
              width: '15%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
          ],
        },
        {
          title: i18n.t('radiologists'),
          children: [
            {
              title: i18n.t('uncertain'), //疑似
              dataIndex: '60',
              key: '60',
              width: '15%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
            {
              title: i18n.t('normal'), //正常
              dataIndex: '44',
              key: '44',
              width: '15%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
          ],
        }
      );
    }
    if (uploadType === '8') {
      columns.push({
        title: i18n.t('QCResult'),
        children: [
          {
            title: i18n.t('unKnown'), //未知
            dataIndex: 'unknown',
            key: 'unknown',
            width: '25%',
            align: 'right',
            render: value => <span>{value || 0}</span>,
          },
          {
            title: i18n.t('normal'), //正常
            dataIndex: 'qcpassed',
            key: 'qcpassed',
            width: '20%',
            align: 'right',
            render: value => <span>{value || 0}</span>,
          },
          {
            title: i18n.t('unqualified'), //未通过
            dataIndex: 'qcunpassed',
            key: 'qcunpassed',
            width: '20%',
            align: 'right',
            render: value => <span>{value || 0}</span>,
          },
        ],
      });
    }
    if (uploadType === '9') {
      columns.push(
        {
          title: '患者数',
          dataIndex: 'patCnt',
          key: 'patCnt',
          width: '10%',
        },
        {
          title: 'AI',
          children: [
            {
              title: i18n.t('abnormal1'), //异常
              dataIndex: 'abnormal',
              key: 'abnormal',
              width: '10%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
          ],
        },
        {
          title: i18n.t('radiologists'),
          children: [
            {
              title: i18n.t('tuberculosis'), //肺结核
              dataIndex: '31',
              key: '31',
              width: '10%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
            {
              title: i18n.t('pneumonia'), //肺炎
              dataIndex: '28',
              key: '28',
              width: '10%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
            {
              title: i18n.t('cancer'), //结节肿块
              dataIndex: '35',
              key: '35',
              width: '10%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
            {
              title: i18n.t('pleural_disease'), //胸膜胸腔
              dataIndex: '23',
              key: '23',
              width: '15%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
          ],
        }
      );
    }
    if (uploadType === '11') {
      columns.push(
        {
          title: '患者数',
          dataIndex: 'patCnt',
          key: 'patCnt',
          width: '20%',
        },
        {
          title: 'AI',
          children: [
            {
              title: i18n.t('abnormal1'), //异常
              dataIndex: 'abnormal',
              key: 'abnormal',
              width: '20%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
          ],
        },
        {
          title: i18n.t('radiologists'),
          children: [
            {
              title: i18n.t('tuberculosis1'), //活动性肺结核
              dataIndex: '31',
              key: 'tuberculosis',
              width: '25%',
              align: 'right',
              render: value => <span>{value || 0}</span>,
            },
          ],
        }
      );
    }

    return columns;
  };

  getHeaderColumns = () => {
    const { uploadType } = this.state;
    const columns = [];
    columns.push(
      {
        title: i18n.t('institution'), //机构
        dataIndex: 'institutionName',
        key: 'institutionName',
        width: '15%',
        render: () => <span>总计</span>,
      },
      {
        title: i18n.t('uploads'), //传片量
        dataIndex: 'sumTotal',
        key: 'sumTotal',
        width: '10%',
      },
      {
        title: i18n.t('chestPA'), //胸部正位片
        dataIndex: 'sumChestPa',
        key: 'sumChestPa',
        width: '10%',
      }
    );
    if (uploadType === '6') {
      columns.push(
        {
          title: '患者数',
          dataIndex: 'sumPatCnt',
          key: 'sumPatCnt',
          width: '10%',
        },
        {
          title: 'AI',
          children: [
            {
              title: i18n.t('abnormal1'), //异常
              dataIndex: 'sumAbnormal',
              key: 'sumAbnormal',
              width: '10%',
              align: 'right',
            },
            {
              title: i18n.t('uncertain'), //疑似
              dataIndex: 'sumViralPneumonia',
              key: 'sumViralPneumonia',
              width: '15%',
              align: 'right',
            },
          ],
        },
        {
          title: i18n.t('radiologists'),
          children: [
            {
              title: i18n.t('uncertain'), //疑似
              dataIndex: 'sum60',
              key: 'sum60',
              width: '15%',
              align: 'right',
            },
            {
              title: i18n.t('normal'), //正常
              dataIndex: 'sum44',
              key: 'sum44',
              width: '15%',
              align: 'right',
            },
          ],
        }
      );
    }
    if (uploadType === '8') {
      columns.push({
        title: i18n.t('QCResult'),
        children: [
          {
            title: i18n.t('unKnown'), //部位
            dataIndex: 'sumUnknown',
            key: 'sumUnknown',
            width: '25%',
            align: 'right',
          },
          {
            title: i18n.t('normal'), //部位
            dataIndex: 'sumQcpassed',
            key: 'sumQcpassed',
            width: '20%',
            align: 'right',
          },
          {
            title: i18n.t('unqualified'), //部位
            dataIndex: 'sumQcunpassed',
            key: 'sumQcunpassed',
            width: '20%',
            align: 'right',
          },
        ],
      });
    }
    if (uploadType === '9') {
      columns.push(
        {
          title: '患者数',
          dataIndex: 'sumPatCnt',
          key: 'sumPatCnt',
          width: '10%',
        },
        {
          title: 'AI',
          children: [
            {
              title: i18n.t('abnormal1'), //部位
              dataIndex: 'sumAbnormal',
              key: 'sumAbnormal',
              width: '10%',
              align: 'right',
            },
          ],
        },
        {
          title: i18n.t('radiologists'),
          children: [
            {
              title: i18n.t('tuberculosis'), //部位
              dataIndex: 'sum31',
              key: 'sum31',
              width: '10%',
              align: 'right',
            },
            {
              title: i18n.t('pneumonia'), //部位
              dataIndex: 'sum28',
              key: 'sum28',
              width: '10%',
              align: 'right',
            },
            {
              title: i18n.t('cancer'), //部位
              dataIndex: 'sum35',
              key: 'sum35',
              width: '10%',
              align: 'right',
            },
            {
              title: i18n.t('pleural_disease'), //部位
              dataIndex: 'sum23',
              key: 'sum23',
              width: '15%',
              align: 'right',
            },
          ],
        }
      );
    }

    if (uploadType === '11') {
      columns.push(
        {
          title: '患者数',
          dataIndex: 'sumPatCnt',
          key: 'sumPatCnt',
          width: '20%',
        },
        {
          title: i18n.t('abnormal1'), //部位
          dataIndex: 'sumAbnormal',
          key: 'sumAbnormal',
          width: '20%',
          align: 'right',
        },
        {
          title: i18n.t('tuberculosis'), //活动性肺结核
          dataIndex: 'sumTuberculosis',
          key: 'sumTuberculosis',
          width: '25%',
          align: 'right',
        }
      );
    }

    return columns;
  };

  sexData = () => {
    const { sexStat } = this.state;
    const data = [['product', i18n.t('male'), i18n.t('female')]];
    sexStat.forEach(item => {
      let f = 0,
        m = 0,
        name = '';
      for (let i in item) {
        name = i;
        f = item[i].F;
        m = item[i].M;
      }
      const current = [i18n.t(name), m, f];
      data.push(current);
    });
    return data;
  };

  setSexChart = () => {
    this.sexData();
    // 基于准备好的dom，初始化echarts实例
    var myChart = echarts.init(document.getElementById('sexChart'));
    // 绘制图表
    myChart.setOption({
      title: {
        text: i18n.t('ageSummary'),
        left: 'center',
        textStyle: {
          color: '#333333',
          fontWeight: 'normal',
          fontSize: 16,
        },
      },
      legend: {
        show: true,
        right: 10,
        top: 10,
        orient: 'horizontal',
        itemWidth: 11,
        itemHeight: 7,
        itemGap: 20,
        data: [
          {
            name: i18n.t('male'),
            icon: 'rect',
            textStyle: { fontSize: 12, color: '#8C8C8C' },
          },
          {
            name: i18n.t('female'),
            icon: 'rect',
            textStyle: { fontSize: 12, color: '#8C8C8C' },
          },
        ],
      },
      tooltip: {},
      dataset: { source: this.sexData() },
      xAxis: { type: 'category' },
      yAxis: {},
      series: [
        {
          type: 'bar',
          barWidth: 21,
          name: i18n.t('male'),
          itemStyle: { color: '#5B8FF9' },
          barGap: '30%',
        },
        {
          type: 'bar',
          barWidth: 21,
          name: i18n.t('female'),
          itemStyle: { color: '#EC7846' },
          barGap: '30%',
        },
      ],
    });
  };

  getLegendData = lenDatas => {
    const { piechart } = this.state;
    let chartData = [];
    lenDatas.forEach(item => {
      for (let i in piechart) {
        if (i === item.id) {
          chartData.push({
            name: i18n.t(item.id),
            value: piechart[i],
            itemStyle: {
              color: item.color,
              borderColor: '#ffffff',
              borderWidth: 1,
            },
          });
        }
      }
    });
    return chartData;
  };

  getlegendName = legNames => {
    let lenArray = [];
    legNames.forEach(item => {
      lenArray.push({
        name: i18n.t(item.id),
        icon: 'circle',
        textStyle: { fontSize: 12, color: '#8C8C8C' },
      });
      return item;
    });
    return lenArray;
  };
  exportDetailExcel = () => {
    let { uploadType, fromTime, toTime, institutionId, title } = this.state;
    let startDate = Date.parse(fromTime);
    let endDate = Date.parse(toTime);
    const days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
    if (!fromTime || !toTime || days > 62) {
      message.warning(
        '导出数据的时间跨度不能超过两个月，请选择日期并搜索后再次导出'
      );
      return;
    }
    const _this = this;
    this.setState({ isLoading: true });

    const post = {
      aiProductType: uploadType,
      fromTime,
      toTime,
      institutionId,
    };
    const search = getParams(post);
    const url = `/ai-web/fromDr/exportExcel?${search}`;
    var xhr = new XMLHttpRequest();
    xhr.open('get', url, true); //url填写后台的接口地址
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    let fileName = title + '.xlsx';
    xhr.responseType = 'blob';
    xhr.onload = function(oEvent) {
      _this.setState({ isLoading: false });
      if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
        //校验是否下载参数
        var content = xhr.response;

        //数据转换为文件下载
        var elink = document.createElement('a');
        elink.download = fileName || 'demo.xlsx';
        elink.style.display = 'none';
        var blob = new Blob([content]);
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      }
    };

    xhr.send(null);
  };

  exportExcel = () => {
    let { uploadType, fromTime, toTime, title, institutionName } = this.state;
    const data = this.state.recordList; // 准备的数据
    var option = {};
    let dataTable = [];
    if (data) {
      for (let i in data) {
        if (data) {
          let obj = {};
          if (uploadType === '6') {
            obj = {
              机构名称: data[i].institutionName, // '列名': 数据
              传片数量: data[i].total || 0,
              胸部正位片数量: data[i].chest_pa || 0,
              患者数: data[i].patCnt || 0,
              AI异常数量: data[i].abnormal || 0,
              AI诊断疑似数量: data[i].viral_pneumonia || 0,
              医生审核疑似数量: data[i]['26'] || 0,
              医生审核正常数量: data[i]['44'] || 0,
            };
          } else if (uploadType === '8') {
            obj = {
              机构名称: data[i].institutionName,
              传片数量: data[i].total || 0,
              胸部正位片数量: data[i].chest_pa || 0,
              未知: data[i].unknown || 0,
              质控正常: data[i].qcpassed || 0,
              质控不合格: data[i].qcunpassed || 0,
            };
          } else if (uploadType === '9') {
            obj = {
              机构名称: data[i].institutionName,
              传片数量: data[i].total || 0,
              胸部正位片数量: data[i].chest_pa || 0,
              患者数: data[i].patCnt || 0,
              AI异常数量: data[i].abnormal || 0,
              医生诊断结果: data[i]['31'] || 0,
              医生诊断肺炎: data[i]['28'] || 0,
              医生审核结节肿块: data[i]['35'] || 0,
              医生诊断胸膜胸腔: data[i]['23'] || 0,
            };
          } else if (uploadType === '11') {
            obj = {
              机构名称: data[i].institutionName,
              传片数量: data[i].total || 0,
              胸部正位片数量: data[i].chest_pa || 0,
              患者数: data[i].patCnt || 0,
              AI异常数量: data[i].abnormal || 0,
              肺结核: data[i]['31'] || 0,
              // 陈旧性肺结核: data[i]['32'] || 0,
            };
          }
          dataTable.push(obj);
        }
      }
    }

    fromTime = fromTime ? fromTime.split(' ')[0] : '未选择';
    toTime = toTime ? toTime.split(' ')[0] : '未选择';

    const fileTitle = i18n.t(title);
    const instName = i18n.t(institutionName);
    option.fileName = `${fileTitle}[${fromTime}-${toTime}]${instName}`;
    //导出的Excel文件名
    let header = [];
    if (uploadType === '6') {
      header = [
        '机构名称',
        '传片数量',
        '胸部正位片数量',
        '患者数',
        'AI异常数量',
        'AI诊断疑似数量',
        '医生审核疑似数量',
        '医生审核正常数量',
      ];
    } else if (uploadType === '8') {
      header = [
        '机构名称',
        '传片数量',
        '胸部正位片数量',
        '未知',
        '质控正常',
        '质控不合格',
      ];
    } else if (uploadType === '9') {
      header = [
        '机构名称',
        '传片数量',
        '胸部正位片数量',
        '患者数',
        'AI异常数量',
        '医生诊断结果',
        '医生诊断肺炎',
        '医生审核结节肿块',
        '医生诊断胸膜胸腔',
      ];
    } else if (uploadType === '11') {
      header = [
        '机构名称',
        '传片数量',
        '胸部正位片数量',
        '患者数',
        'AI异常数量',
        '肺结核',
        // '陈旧性肺结核',
      ];
    }
    option.datas = [
      {
        sheetData: dataTable,
        sheetName: 'sheet',
        sheetFilter: header,
        sheetHeader: header,
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  };

  setFooter = () => {
    let { recordList, uploadType } = this.state;
    let sumData = {};
    const columns = this.getHeaderColumns();
    if (uploadType === '6') {
      let sum60 = 0,
        sum44 = 0,
        sumTotal = 0,
        sumAbnormal = 0,
        sumChestPa = 0,
        sumPatCnt = 0,
        sumViralPneumonia = 0;
      recordList.forEach(item => {
        sum60 += item[60] || 0;
        sum44 += item[44] || 0;
        sumTotal += item.total || 0;
        sumAbnormal += item.abnormal || 0;
        sumChestPa += item.chest_pa || 0;
        sumPatCnt += item.patCnt;
        sumViralPneumonia += item.viral_pneumonia || 0;
      });
      sumData = [
        {
          id: 0,
          sum60,
          sum44,
          sumTotal,
          sumAbnormal,
          sumChestPa,
          sumPatCnt,
          sumViralPneumonia,
        },
      ];
      return (
        <Table
          columns={columns}
          dataSource={sumData}
          rowKey={record => record.id}
          key={record => record.id}
          className="list-item"
          bordered
          pagination={false}
          showHeader={false}
          scroll={{ y: 60 }}
        />
      );
    } else if (uploadType === '8') {
      let sumTotal = 0,
        sumChestPa = 0,
        sumUnknown = 0,
        sumQcpassed = 0,
        sumQcunpassed = 0;
      recordList.forEach(item => {
        sumTotal += item.total || 0;
        sumChestPa += item.chest_pa || 0;
        sumUnknown += item.unknown || 0;
        sumQcpassed += item.qcpassed || 0;
        sumQcunpassed += item.qcunpassed || 0;
      });
      sumData = [
        {
          id: 0,
          sumTotal,
          sumChestPa,
          sumUnknown,
          sumQcpassed,
          sumQcunpassed,
        },
      ];
      return (
        <Table
          columns={columns}
          dataSource={sumData}
          rowKey={record => record.id}
          key={record => record.id}
          className="list-item"
          bordered
          pagination={false}
          showHeader={false}
          scroll={{ y: 60 }}
        />
      );
    } else if (uploadType === '9') {
      let sumTotal = 0,
        sumChestPa = 0,
        sumPatCnt = 0,
        sumAbnormal = 0,
        sum31 = 0,
        sum28 = 0,
        sum35 = 0,
        sum23 = 0;
      recordList.forEach(item => {
        sumTotal += item.total || 0;
        sumChestPa += item.chest_pa || 0;
        sumPatCnt += item.patCnt || 0;
        sumAbnormal += item.abnormal || 0;
        sum31 += item[31] || 0;
        sum28 += item[28] || 0;
        sum35 += item[35] || 0;
        sum23 += item[23] || 0;
      });
      sumData = [
        {
          id: 0,
          sumTotal,
          sumChestPa,
          sumPatCnt,
          sumAbnormal,
          sum31,
          sum28,
          sum35,
          sum23,
        },
      ];
      return (
        <Table
          columns={columns}
          dataSource={sumData}
          rowKey={record => record.id}
          key={record => record.id}
          className="list-item"
          bordered
          pagination={false}
          showHeader={false}
          scroll={{ y: 60 }}
        />
      );
    } else if (uploadType === '11') {
      let sumTotal = 0,
        sumChestPa = 0,
        sumPatCnt = 0,
        sumAbnormal = 0,
        sumTuberculosis = 0,
        sumOld = 0;
      recordList.forEach(item => {
        sumTotal += item.total || 0;
        sumChestPa += item.chest_pa || 0;
        sumPatCnt += item.patCnt || 0;
        sumAbnormal += item.abnormal || 0;
        sumTuberculosis += item[31] || 0;
        sumOld += item[32] || 0;
      });
      sumData = [
        {
          id: 0,
          sumTotal,
          sumChestPa,
          sumPatCnt,
          sumAbnormal,
          sumTuberculosis,
          sumOld,
        },
      ];
      return (
        <Table
          columns={columns}
          dataSource={sumData}
          rowKey={record => record.id}
          key={record => record.id}
          className="list-item"
          bordered
          pagination={false}
          showHeader={false}
          scroll={{ y: 60 }}
        />
      );
    }
  };
  handleChange = (value, option) => {
    this.setState({ institutionName: option.props.title });
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  render() {
    const { title, institutionData, tableHeight, isLoading } = this.state;
    let { recordList, moreFilter, showMoreFilter } = this.state;

    const { RangePicker } = DatePicker;
    const dateFormat = 'YYYY-MM-DD';

    const columns = this.getColumns();

    const { getFieldDecorator } = this.props.form;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');

    const today = formatDate(new Date(), dateFormat);

    return (
      <Translation>
        {t => (
          <div className="form-bg">
            <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
            {isLoading && (
              <div className="spin-box-bg">
                <Spin indicator={<Icon type="loading" spin />} />
              </div>
            )}
            <div className="theme-content">
              <ConnectedHeader
                toggleCollapsed={() => changeListWidth(this)}
                login={false}
                home={true}
              />
              <div className="theme-box">
                <div className="bread-crumb">
                  <Breadcrumb>
                    {breadItem([t('statisticalAnalysis'), t(title)])}
                  </Breadcrumb>
                  {breadBack(this)}
                </div>
                <div className="box" style={{ width: this.state.listWidth }}>
                  <div className="left">
                    <Form
                      className={`ant-advanced-search-form${
                        !moreFilter && showMoreFilter ? ' notOverflow' : ''
                      }`}
                      onSubmit={this.handleSearch}
                      layout="inline"
                    >
                      <div className="searchBox">
                        <div className="searchBoxContent">
                          <Form.Item label={t('uploadTime')} colon={false}>
                            <ConfigProvider
                              allowClear={true}
                              locale={
                                this.state.i18nextLng === 'zh-CN' ? zh_CN : null
                              }
                            >
                              {getFieldDecorator('time', {
                                initialValue: [
                                  moment(today, dateFormat),
                                  moment(today, dateFormat),
                                ],
                              })(
                                <RangePicker
                                  allowClear={true}
                                  format={dateFormat}
                                  placeholder={[t('startDate'), t('endDate')]}
                                />
                              )}
                            </ConfigProvider>
                          </Form.Item>
                          <Form.Item label={t('institution')} colon={false}>
                            {getFieldDecorator('institution', {})(
                              <Select
                                allowClear={true}
                                showSearch
                                placeholder="全部"
                                style={{ width: 240 }}
                                defaultActiveFirstOption={false}
                                showArrow={false}
                                filterOption={false}
                                onSearch={this.handleInstitutionSearch}
                                onChange={this.handleChange}
                                notFoundContent={null}
                              >
                                {institutionOptions}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      </div>
                      <div className="searchOptBox">
                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="btn-search"
                          >
                            {this.state.loadingIconShow ? (
                              <Icon type="sync" spin />
                            ) : (
                              <Icon type="search" />
                            )}
                            {t('search')}
                          </Button>
                          <Button
                            icon="redo"
                            style={{ marginLeft: 8 }}
                            className="btn-reset"
                            onClick={this.handleReset}
                          >
                            {t('reset')}
                          </Button>
                        </Form.Item>
                        {this.state.showMoreFilter ? (
                          <Button
                            type="link"
                            className="moreFilter"
                            onClick={() => {
                              this.setState({
                                moreFilter: !moreFilter,
                              });
                            }}
                            icon={moreFilter ? 'down' : 'up'}
                          >
                            {moreFilter ? '展开' : '收起'}
                          </Button>
                        ) : null}
                      </div>
                    </Form>
                    <div>
                      <Row>
                        <Col span={12}>
                          <div id="sexChart" style={{ height: '300px' }}></div>
                        </Col>
                      </Row>
                    </div>
                    <div className="export-box">
                      <Button
                        icon="save"
                        className="btn-export"
                        disabled={recordList.length === 0}
                        onClick={this.exportExcel}
                      >
                        {i18n.t('export')}
                      </Button>
                      <Button
                        icon="save"
                        className="btn-export"
                        disabled={recordList.length === 0}
                        onClick={this.exportDetailExcel}
                      >
                        导出明细
                      </Button>
                    </div>

                    <div className="history-list">
                      <Table
                        columns={columns}
                        dataSource={recordList}
                        rowKey={record => record.institutionId}
                        key={record => record.institutionId}
                        className="list-item"
                        scroll={{ y: tableHeight }}
                        bordered
                        footer={() => this.setFooter()}
                        locale={{ emptyText: <TableEmpty /> }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(
  Form.create()(withTranslation('Common')(ChartsWithData))
);
